import React, { useState, useContext, useEffect } from 'react';
import { isEmpty, remove, find } from 'lodash'
import { GeneralContext } from '../../../context/'

const Pagination = (props) => {
  const generalContext = useContext(GeneralContext)
  const { currentRoute, pagination, setPagination } = generalContext
  const { aclass, count = 12, unit = 6 } = props

  const plpPagination = find(pagination, { currentRoute })
  const [page, setPage] = useState(!isEmpty(plpPagination) ? plpPagination.plpPage : 1)

  useEffect( () => {
    setPage(!isEmpty(plpPagination) ? plpPagination.plpPage : 1)
  }, [currentRoute, pagination]) // eslint-disable-line

  let pageCount = parseInt(count / unit) + (0 < (count % unit) ? 1 : 0)
  let pageNumbers = []

  for (let i = -1; i < 2 && pageCount >= 3; i++) {
    if ( 1 < page && page < pageCount)
      pageNumbers.push(page + i)
    if (1 === page)
      pageNumbers.push(page + i + 1)
    if ( page === pageCount )
      pageNumbers.push(page + i - 1)
  }

  for (let i = 0; i < pageCount && pageCount < 3; i++) {
    pageNumbers.push(i + 1)
  }

  // useEffect( () => {
  //   if (props.onChange) {
  //     setPage(1)
  //     props.onChange(0)
  //   }
  // }, [filters]) // eslint-disable-line

  const onPageLink = (e, index) => {
    setPage(index)

    // Paginacion de contexto
    const currentPagination = pagination
    remove(currentPagination, n =>
      n.currentRoute === currentRoute
    )
    currentPagination.push({
      currentRoute,
      plpPage: index
    })
    setPagination(currentPagination)

    if (props.onChange) {
      props.onChange(index - 1)
    }
  }

  const onPrev = () => {
    setPage(page - 1)

    // Paginacion de contexto
    const currentPagination = pagination
    remove(currentPagination, n =>
      n.currentRoute === currentRoute
    )
    currentPagination.push({
      currentRoute,
      plpPage: page - 1, 
    })
    setPagination(currentPagination)

    if (props.onChange) {
      props.onChange(page - 2)
    }
  }

  const onNext = () => {
    setPage(page + 1)

    // Paginacion de contexto
    const currentPagination = pagination
    remove(currentPagination, n =>
      n.currentRoute === currentRoute
    )
    currentPagination.push({
      currentRoute,
      plpPage: page + 1, 
    })
    setPagination(currentPagination)

    if (props.onChange) {
      props.onChange(page)
    }
  }

  return (
    <nav aria-label="Page navigation" style={ { display: 0 === count ? 'none' : '' } }>
      <ul className={ `pagination ${aclass}` }>
        <li className={ `page-item ${1 === page ? 'disabled' : ''}` } >
          <button className="page-link page-link-prev" to="#" aria-label="Previous" tabIndex="-1" aria-disabled="true" onClick={onPrev}>
            <span aria-hidden="true"><i className="mdi mdi-chevron-left"></i></span>Anterior
          </button>
        </li>

        {
          pageNumbers.map((item, index) => (
            <li
              className={`page-item ${item === page ? 'active' : ''}`}
              aria-current="page"
              key={ index }
            >
              <button className="page-link" to="#" onClick={(e) => onPageLink(e, item)}>{item}</button>
            </li>
          ))
        }

        {pageCount > 3 && page < pageCount ? <li className="page-item-total">de&nbsp;{pageCount}</li> : ''}

        <li className={ `page-item ${pageCount === page ? 'disabled' : ''}` }>
          <button className="page-link page-link-next" to="#" aria-label="Next" onClick={onNext}>
            Siguiente <span aria-hidden="true"><i className="mdi mdi-chevron-right"></i></span>
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default Pagination
